import React, { createContext, useContext, useState } from "react";
import { User } from "../types/User";
import Cookies from "js-cookie";

interface AuthContextInterface {
  loggedUser?: User;
  token?: string;
  setLoggedUser: React.Dispatch<React.SetStateAction<User | undefined>>;
  setToken: React.Dispatch<React.SetStateAction<string | undefined>>;
  newNotifications?: number;
  setNewNotifications: React.Dispatch<React.SetStateAction<number | undefined>>;
  handleLogout: VoidFunction;
}

const AuthContext = createContext<AuthContextInterface>(
  {} as AuthContextInterface
);

export const AuthProvider = ({ children }: React.PropsWithChildren) => {
  const cookie = Cookies.get(
    window.__env.AUTH_TOKEN_NAME || "coaching-master-token"
  );
  const [loggedUser, setLoggedUser] = useState<User>();
  const [token, setToken] = useState<string | undefined>(cookie);
  const [newNotifications, setNewNotifications] = useState<
    number | undefined
  >();

  const handleLogout = () => {
    setLoggedUser(undefined);
    setToken(undefined);
    Cookies.remove(window.__env.AUTH_TOKEN_NAME || "coaching-master-token");
    Cookies.remove(
      window.__env.AUTH_REFRESH_TOKEN_NAME || "coaching-master-refresh-token"
    );
  };

  return (
    <AuthContext.Provider
      value={{
        loggedUser,
        token,
        setLoggedUser,
        setToken,
        newNotifications,
        setNewNotifications,
        handleLogout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
